export default "__VITE_ASSET__1ec96964__"